import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const Amperes: ConvertableUnit = {
  label: "A",
  longLabel: "Amps",
  toStandardUnit: VA => VA,
  toThisUnit: VA => VA
};

export const KiloAmperes: ConvertableUnit = {
  label: "kA",
  longLabel: "KiloAmps",
  toStandardUnit: kA => kA * 1000,
  toThisUnit: A => A / 1000
};

const unitList = [Amperes, KiloAmperes];
export const CurrentUnits = {
  Amperes,
  KiloAmperes,
  options: buildOptions(unitList)
};
